var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ExercisesScreen"},[_c('div',{staticClass:"ScreenHeader"},[_c('h1',[_vm._v("Ejercicios")])]),_c('div',{staticClass:"Container"},[_c('p',[_vm._v("ExercisesScreen")])])])
}]

export { render, staticRenderFns }